/* PC STATION LB / Clean Mobile V6: simple facet accordion and restrained UI */
(() => {
  document.addEventListener('click', (event) => {
    const el = event.target;
    if (!(el instanceof Element)) return;
    const summary = el.closest('#FacetFiltersFormMobile .mobile-facets__details.js-filter > summary.mobile-facets__summary');
    if (!summary || !summary.closest('.pcslb-facets-bottom-sheet-v3')) return;
    const details = summary.parentElement;
    const main = details.closest('.mobile-facets__main');
    if (!main) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const opening = !details.open;
    for (const other of main.querySelectorAll('.mobile-facets__details[open]')) {
      if (other !== details) {
        other.open = false;
        other.classList.remove('menu-opening');
        other.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      }
    }
    details.open = opening;
    details.classList.toggle('menu-opening', opening);
    summary.setAttribute('aria-expanded', String(opening));
    main.classList.remove('submenu-open');
  }, true);
})();